import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';

let PLAUSIBILISIERUNG: any = {};

class Plausibilisierung {

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private contextServiceKey = `TMP_DATA_${IDs.ENT_PLAUSIBILISIERUNG}`;

    getPlausiValue(params: string[], fallback?: any): any {
        const bereich_key: string = this.apiService.getBereichKey();
        // const data: any = this.contextService.get(this.contextServiceKey);
        let value = null;

        for (let i: number = 0; i < params.length; ++i) {
            const param = params[i];
            const key: string = `${bereich_key ? `${bereich_key}#` : ''}${param}`;

            if (typeof PLAUSIBILISIERUNG[key] !== 'undefined') {
                value = PLAUSIBILISIERUNG[key];
                break;
            } else if (typeof PLAUSIBILISIERUNG[param] !== 'undefined') {
                value = PLAUSIBILISIERUNG[param];
                break;
            }
            // if (Array.isArray(data)) {
            //     const fnd: any = data.find((r: any) => r.parameter === param && r.bereich_key_orig === bereich_key);
            //     if (fnd) {
            //         value = fnd.wert;
            //         break;
            //     }
            //     const fnd2: any = data.find((r: any) => r.parameter === param && !r.bereich_key);
            //     if (fnd2) {
            //         value = fnd2.wert;
            //         break;
            //     }
            // }
            // console.log('Plausi-Key nicht gefunden:', param, bereich_key);
        }

        if (value !== null) {
            return value;
        } else if (typeof fallback !== 'undefined') {
            return fallback;
        }
    }

    storePlausiData(data: any[]): void {
        this.contextService.set(this.contextServiceKey, data);
    }
}

const plausi = new Plausibilisierung();

export function getPlausiValue(param: string | string[], fallback?: any) {
    const params: string[] = Array.isArray(param) ? param : [param];

    return plausi.getPlausiValue(params, fallback);
}

export function storePlausiData(data: any[]) {
    PLAUSIBILISIERUNG = {};
    // plausi.storePlausiData(data);
    (data || []).forEach((item: any) => {
        PLAUSIBILISIERUNG[`${item.bereich_key_orig ? `${item.bereich_key_orig}#` : ''}${item.parameter}`] = item.wert;
    });
}
